export enum MessageTypeEnum{
    default = 0,
    success = 1,
    error = 2, 
    warning = 3
}